import {
	Avatar,
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "@exopengithub/exokit";
import { IconLogout } from "@tabler/icons-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import type { User } from "../../common/service/types/UserTypes.js";
import { getGravatarUrl } from "../planning/utils/getGravatarUrl.js";
import { useDisplayName } from "src/common/utils/hooks/useDisplayName.js";
import { ProfileModal } from "../profile/ProfileModal.js";

import { logout } from "src/auth0.js";

interface SidebarUserSectionProps {
	sidebarOpen: boolean;
	user: User;
}

export const SidebarUserSection = ({
	sidebarOpen,
	user,
}: SidebarUserSectionProps) => {
	const { t } = useTranslation();
	const displayName = useDisplayName(user);
	const [profileOpen, setProfileOpen] = useState(false);

	const avatar = (
		<Avatar
			src={getGravatarUrl(user.email)}
			size="md"
			alt=""
			className="mr-1 align-middle"
		/>
	);

	return (
		<div
			className="flex items-center gap-2"
			data-experience-anchor="profile-menu"
		>
			<ProfileModal
				open={profileOpen}
				onClose={() => {
					setProfileOpen(false);
				}}
			/>
			<Tooltip placement="right">
				<TooltipTrigger asChild>
					<button
						type="button"
						aria-label={t("My profile")}
						onClick={() => {
							setProfileOpen(true);
						}}
					>
						{avatar}
					</button>
				</TooltipTrigger>
				<TooltipContent>{t("My profile")}</TooltipContent>
			</Tooltip>
			{sidebarOpen && (
				<>
					<button
						type="button"
						className="grow overflow-hidden text-left"
						onClick={() => {
							setProfileOpen(true);
						}}
					>
						<div
							className="text-sm font-medium text-primary-800 truncate"
							data-testid="sidebar-user-name"
						>
							{displayName}
						</div>
						<div className="text-xs truncate text-primary-800">
							{user.email}
						</div>
					</button>
					<Tooltip>
						<TooltipTrigger asChild>
							<button
								aria-label={t("Sign out")}
								className="cursor-pointer text-gray-500"
								type="button"
								onClick={() => {
									logout();
								}}
							>
								<IconLogout size={16} strokeWidth={1.5} />
							</button>
						</TooltipTrigger>
						<TooltipContent>{t("Sign out")}</TooltipContent>
					</Tooltip>
				</>
			)}
		</div>
	);
};
